import React, { Component } from 'react';
// Bar graph
import FreightByLoBBar from "./FreightByLoBBar";
// Table state -> Kind -> Customers
import ShipToStateTable from "./ShipToStateTable";
// Table salesPerson -> Kind -> Customers
import SalesPersonStateTable from "./SalesPersonStateTable";
// Map
import USAMap from "./USAMap";
import { getElixirApiData } from "../../services/CABE";

// Menu
import { Menu } from "../../components/Menu/Menu";

// States and location
const STATE_COORDS = {
  AL: { lat: 32.8067, lng: -86.7911, label: "Alabama" },
  AK: { lat: 61.3707, lng: -152.4044, label: "Alaska" },
  AZ: { lat: 33.7298, lng: -111.4312, label: "Arizona" },
  AR: { lat: 34.9697, lng: -92.3731, label: "Arkansas" },
  CA: { lat: 36.7783, lng: -119.4179, label: "California" },
  CO: { lat: 39.5501, lng: -105.7821, label: "Colorado" },
  CT: { lat: 41.6032, lng: -73.0877, label: "Connecticut" },
  DE: { lat: 38.9108, lng: -75.5277, label: "Delaware" },
  FL: { lat: 27.6648, lng: -81.5158, label: "Florida" },
  GA: { lat: 32.1574, lng: -82.9071, label: "Georgia" },
  HI: { lat: 19.8987, lng: -155.6659, label: "Hawaii" },
  ID: { lat: 44.0682, lng: -114.7420, label: "Idaho" },
  IL: { lat: 40.6331, lng: -89.3985, label: "Illinois" },
  IN: { lat: 40.2672, lng: -86.1349, label: "Indiana" },
  IA: { lat: 41.8780, lng: -93.0977, label: "Iowa" },
  KS: { lat: 39.0119, lng: -98.4842, label: "Kansas" },
  KY: { lat: 37.8393, lng: -84.2700, label: "Kentucky" },
  LA: { lat: 31.2448, lng: -92.1450, label: "Louisiana" },
  ME: { lat: 45.2538, lng: -69.4455, label: "Maine" },
  MD: { lat: 39.0458, lng: -76.6413, label: "Maryland" },
  MA: { lat: 42.4072, lng: -71.3824, label: "Massachusetts" },
  MI: { lat: 44.3148, lng: -85.6024, label: "Michigan" },
  MN: { lat: 46.7296, lng: -94.6859, label: "Minnesota" },
  MS: { lat: 32.3547, lng: -89.3985, label: "Mississippi" },
  MO: { lat: 37.9643, lng: -91.8318, label: "Missouri" },
  MT: { lat: 46.8797, lng: -110.3626, label: "Montana" },
  NE: { lat: 41.4925, lng: -99.9018, label: "Nebraska" },
  NV: { lat: 38.8026, lng: -116.4194, label: "Nevada" },
  NH: { lat: 43.1939, lng: -71.5724, label: "New Hampshire" },
  NJ: { lat: 40.0583, lng: -74.4057, label: "New Jersey" },
  NM: { lat: 34.5199, lng: -105.8701, label: "New Mexico" },
  NY: { lat: 43.2994, lng: -74.2179, label: "New York" },
  NC: { lat: 35.7596, lng: -79.0193, label: "North Carolina" },
  ND: { lat: 47.5515, lng: -101.0020, label: "North Dakota" },
  OH: { lat: 40.4173, lng: -82.9071, label: "Ohio" },
  OK: { lat: 35.0078, lng: -97.0929, label: "Oklahoma" },
  OR: { lat: 43.8041, lng: -120.5542, label: "Oregon" },
  PA: { lat: 41.2033, lng: -77.1945, label: "Pennsylvania" },
  RI: { lat: 41.5801, lng: -71.4774, label: "Rhode Island" },
  SC: { lat: 33.8361, lng: -81.1637, label: "South Carolina" },
  SD: { lat: 43.9695, lng: -99.9018, label: "South Dakota" },
  TN: { lat: 35.5175, lng: -86.5804, label: "Tennessee" },
  TX: { lat: 31.9686, lng: -99.9018, label: "Texas" },
  UT: { lat: 39.3210, lng: -111.0937, label: "Utah" },
  VT: { lat: 44.5588, lng: -72.5778, label: "Vermont" },
  VA: { lat: 37.4316, lng: -78.6569, label: "Virginia" },
  WA: { lat: 47.7511, lng: -120.7401, label: "Washington" },
  WV: { lat: 38.5976, lng: -80.4549, label: "West Virginia" },
  WI: { lat: 43.7844, lng: -88.7879, label: "Wisconsin" },
  WY: { lat: 43.0759, lng: -107.2903, label: "Wyoming" },
  DC: { lat: 38.9072, lng: -77.0369, label: "Washington, DC" }
};

// Set markers for map
function buildStateMarkers(invoices) {
  // 1) conteo por estado
  const counts = invoices.reduce((acc, inv) => {
    const st = inv && inv.shiptostate ? String(inv.shiptostate).trim().toUpperCase() : "";
    if (!st) return acc;

    acc[st] = (acc[st] || 0) + 1;
    return acc;
  }, {});

  // 2) convertir a markers con coords
  const markers = Object.keys(counts)
    .map((st) => {
      const meta = STATE_COORDS[st];
      if (!meta) return null; // si no hay coordenadas, lo ignoramos

      return {
        lat: meta.lat,
        lng: meta.lng,
        value: counts[st],
        label: meta.label + " (" + st + ")"
      };
    })
    .filter(Boolean);

  return markers;
}

// Functions to group by state.
function toNumber(v) {
  if (v === null || v === undefined) return 0;
  if (typeof v === "number") return v;
  var s = String(v).trim();
  if (!s) return 0;
  var n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

function buildDemoRows(invoices) {
  var groups = {};

  for (var i = 0; i < invoices.length; i++) {
    var inv = invoices[i];

    var st = inv && inv.shiptostate ? String(inv.shiptostate).trim().toUpperCase() : "";
    var route = inv && inv.udf_ruta ? String(inv.udf_ruta).trim() : "";
    var billTo = inv && inv.billtoname ? String(inv.billtoname).trim() : "";

    if (!st) st = "N/A";
    if (!route) route = "N/A";
    if (!billTo) billTo = "N/A";

    var key = st + "||" + route + "||" + billTo;

    if (!groups[key]) {
      groups[key] = {
        ShipToState: st,
        ProductLineDesc: route,   // udf_ruta
        BillToName: billTo,
        Envios: 0,
        FreightAmt: 0,
        _carrierSum: 0
      };
    }

    groups[key].Envios += 1;
    groups[key].FreightAmt += toNumber(inv.freightamt);
    groups[key]._carrierSum += toNumber(inv.carrier_price);
  }

  // Convertir a array + diffPct
  var rows = Object.keys(groups).map(function (k) {
    var r = groups[k];
    var cost = r.FreightAmt;      // cobrado (freightamt)
    var payed = r._carrierSum;    // pagado (carrier_price)

    var diffPct = 0;
    var difference = 0;
    var subsidy = 0;
    if (cost !== 0) {
      diffPct = ((payed - cost) / cost) * 100;
      difference = (cost - payed);
      subsidy =  (difference / payed) * 100;
    }

    return {
      ShipToState: r.ShipToState,
      ProductLineDesc: r.ProductLineDesc,
      BillToName: r.BillToName,
      Envios: r.Envios,
      FreightAmt: Math.round(r.FreightAmt * 100) / 100,
      diffPct: Math.round(diffPct),
      payed: Math.round(payed), 
      difference: Math.round(difference), 
      subsidy: Math.round(subsidy), 
    };
  });

  // opcional: ordenar por FreightAmt desc
  rows.sort(function (a, b) {
    return (b.FreightAmt || 0) - (a.FreightAmt || 0);
  });

  return rows;
}

// Function to create table for gruop by salesman
function buildSalesPersonRows(invoices) {
  var groups = {};

  for (var i = 0; i < invoices.length; i++) {
    var inv = invoices[i];

    var sp = inv && inv.salespersonno ? String(inv.salespersonno).trim().toUpperCase() : "N/A";
    var route = inv && inv.udf_ruta ? String(inv.udf_ruta).trim() : "N/A";
    var billTo = inv && inv.billtoname ? String(inv.billtoname).trim() : "N/A";

    var key = sp + "||" + route + "||" + billTo;

    if (!groups[key]) {
      groups[key] = {
        SalesPerson: sp,
        ProductLineDesc: route,
        BillToName: billTo,

        Facturado: 0,          // pendiente
        FleteCobrado: 0,
        FacturaCarrier: 0,
        SubsidioCantidad: 0
      };
    }

    var freight = toNumber(inv.freightamt);
    var carrier = toNumber(inv.carrier_price);

    groups[key].FleteCobrado += freight;
    groups[key].FacturaCarrier += carrier;
    groups[key].SubsidioCantidad += (carrier - freight);
  }

  var rows = Object.keys(groups).map(function (k) {
    var r = groups[k];

    var pct = 0;
    if (r.FleteCobrado !== 0) {
      pct = (r.SubsidioCantidad / r.FleteCobrado) * 100;
    }

    return {
      SalesPerson: r.SalesPerson,
      ProductLineDesc: r.ProductLineDesc,
      BillToName: r.BillToName,
      Facturado: r.Facturado,
      FleteCobrado: Math.round(r.FleteCobrado),
      FacturaCarrier: Math.round(r.FacturaCarrier),
      SubsidioCantidad: Math.round(r.SubsidioCantidad),
      SubsidioProcentaje: Math.round(pct) // entero como tu demo (23)
    };
  });

  // opcional: ordenar por SubsidioCantidad asc/desc (ajusta a tu gusto)
  rows.sort(function (a, b) {
    return (b.SubsidioCantidad || 0) - (a.SubsidioCantidad || 0);
  });

  return rows;
}

// Component
export default class Logistics extends Component {
  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
    // State
    this.state = {
      year: "2025",
      month: "12",
      salesMan: "all",
      line: "all",
      invoices: [],
      total_sales: 0,
      total_sales_porcent: 0,
      sales_utility: 0,
      subsidy_porcent: 0,
      subsidy_porcent_sales: 0,
      freight_charged: 0,
      freight_payed: 0,
      freight_pallet: 0,
      freight_distributor: 0,
      freight_supermarket: 0,
      freight_warehouse: 0,
      markers: [],
      tableByStates: [],
      tableBySalesman: []
    }
  }

  componentDidMount() {
    this.getInvoices(this.state.year, this.state.month, this.state.salesMan);
  }

  async getInvoices(year, month, salesMan) {
    const data = {
      year: year,
      month: month,
      salesman: salesMan
    };

    const result = await getElixirApiData('/get-invoices-report', data);
    // depende tu helper: a veces viene en result.data
    const payload = (result && result.data) ? result.data : result;

    // si viene como [["key", value], ...] => lo pasamos a objeto
    const obj = Array.isArray(payload) ? Object.fromEntries(payload) : payload;
    // Get invoices list
    const invoices = (obj && obj.invoices) ? obj.invoices : [];
    // Set markers from invoices
    const markers = buildStateMarkers(invoices);
    // Group by states
    var demoRows = buildDemoRows(invoices);
    // Group by salesman
    var demoSalesPersonRows = buildSalesPersonRows(invoices);

    this.setState({
      invoices: invoices,
      markers: markers,
      tableByStates: demoRows,
      tableBySalesman: demoSalesPersonRows,
      // stats
      total_sales: obj.total_sales,
      total_sales_porcent: obj.total_sales_porcent,
      sales_utility: obj.sales_utility,
      subsidy_porcent: obj.subsidy_porcent,
      subsidy_porcent_sales: obj.subsidy_porcent_sales,
      freight_charged: obj.freight_charged,
      freight_payed: obj.freight_payed,
      freight_pallet: obj.freight_pallet,
      freight_distributor: obj.freight_distributor,
      freight_supermarket: obj.freight_supermarket,
      freight_warehouse: obj.freight_warehouse
    });
  }

  state = {
    Refresh: false
  }

  render() {
    return (
      <div id="GeneralPages" className="page">
        {/* Main menu */}
        <Menu Refresh={this.state.Refresh} Father={this} />

        <div className="container-fluid mayaland-dash py-4">
          {/* HEADER / BRAND + KPI TILES */}
          <div className="row g-3 align-items-stretch mt-4">

            {/* KPI tiles */}
            <div className="">
              <div className="row g-2 justify-content-center">
                <div className="col-12 col-md-2">
                  <div className="card kpi-tile primary">
                    <div className="kpi-label">FLETE PAGADO</div>
                    <div className="kpi-value">$ -{this.state.total_sales}</div>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <div className="card kpi-tile danger">
                    <div className="kpi-label">FLETE PAGADO / VENTAS</div>
                    <div className="kpi-value">{this.state.total_sales_porcent}</div>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <div className="card kpi-tile danger">
                    <div className="kpi-label">DIFERENCIA = F.C. - F.P.</div>
                    <div className="kpi-value">$ {this.state.sales_utility}</div>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <div className="card kpi-tile warning">
                    <div className="kpi-label">SUBSIDIO = DIF / F.P.</div>
                    <div className="kpi-value">-{this.state.subsidy_porcent}</div>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <div className="card kpi-tile info">
                    <div className="kpi-label">SUBSIDIO / VENTAS</div>
                    <div className="kpi-value">-{this.state.subsidy_porcent_sales}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FILTERS */}
          <div className="row g-3 mt-1">
            <div className="col-12">
              <div className="card glass-card p-3">
                <div className="row g-3">
                  <div className="col-6 col-md-3">
                    <label className="mb-1 darkerPurpleText">Year</label>
                    <select
                      className="form-select form-select-sm"
                      value={String(this.state.year)}
                      onChange={(e) => {
                        const newYear = parseInt(e.target.value, 10);

                        this.setState({ year: newYear }, () => {
                          this.getInvoices(newYear, this.state.month, this.state.salesMan);
                        });
                      }}
                    >
                      <option value="2026">2026</option>
                      <option value="2025">2025</option>
                      <option value="2024">2024</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="mb-1 darkerPurpleText">Salesperson</label>
                    <select
                      className="form-select form-select-sm"
                      value={String(this.state.salesMan)}
                      onChange={(e) => {
                        const newPerson = parseInt(e.target.value, 10);

                        this.setState({ salesMan: newPerson }, () => {
                          this.getInvoices(this.state.year, this.state.month, newPerson);
                        });
                      }}
                    >
                      <option value="all">All</option>
                      <option value="AM">AM</option>
                      <option value="RR">RR</option>
                      <option value="WW">WW</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="mb-1 darkerPurpleText">Month</label>
                    <select
                      className="form-select form-select-sm"
                      value={this.state.month || ""}
                      onChange={(e) => {
                        const newMonth = e.target.value; // "" | "01".."12"

                        this.setState({ month: newMonth }, () => {
                          this.getInvoices(this.state.year, newMonth, this.state.salesMan);
                        });
                      }}
                    >
                      <option value="all">All</option>
                      <option value="01">Jan</option>
                      <option value="02">Feb</option>
                      <option value="03">Mar</option>
                      <option value="04">Apr</option>
                      <option value="05">May</option>
                      <option value="06">Jun</option>
                      <option value="07">Jul</option>
                      <option value="08">Aug</option>
                      <option value="09">Sep</option>
                      <option value="10">Oct</option>
                      <option value="11">Nov</option>
                      <option value="12">Dec</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="mb-1 darkerPurpleText">Business line</label>
                    <select className="form-select form-select-sm">
                      <option value="all">All</option>
                      <option value="Pallet">Pallet</option>
                      <option value="Distributor">Distributor</option>
                      <option value="Supermarket">Supermarket</option>
                      <option value="Warehouse">Warehouse</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MAIN VISUALS */}
          <div className="row g-3 mt-1">
            {/* Pie + Bar stacked column (left) */}
            <div className="col-12 col-xl-4 d-flex flex-column gap-3">
              <div className="card glass-card p-3 flex-fill">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 fw-bold darkerPurpleText">Por Línea de Negocio</h6>
                  <span className="badge bg-light text-body-tertiary text-primary">{this.state.year}</span>
                </div>
                <div className="chart-placeholder rounded-3" data-chart="pie-lob">
                  <FreightByLoBBar
                    labels={["Pallet", "Distributor", "Supermarket", "Warehouse"]}
                    values={[this.state.freight_pallet, this.state.freight_distributor, this.state.freight_supermarket, this.state.freight_warehouse]}
                  />
                </div>
              </div>

              <div className="card glass-card p-3 flex-fill">
                <h6 className="mb-2 fw-bold darkerPurpleText">Flete Cobrado vs Pagado</h6>
                <div className="chart-placeholder rounded-3" data-chart="bar-freight">
                  <FreightByLoBBar
                    labels={["Flete cobrado", "Flete pagado"]}
                    values={[this.state.freight_charged, this.state.freight_payed]}
                  />
                </div>
              </div>
            </div>

            {/* Map (right large) */}
            <div className="col-12 col-xl-8">
              <div className="card glass-card p-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 fw-bold darkerPurpleText">Distribución en USA</h6>
                </div>
                <div className="map-placeholder rounded-3" data-viz="usa-map">
                  <USAMap
                    points={this.state.markers}
                    onReady={function (map) {
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* TABLES */}
          <div className="row gy-3 gx-3 mt-3 gap-fix">
            {/* Left table: ShipToState */}
            <div className="col-12 col-lg-6 d-flex justify-content-center">
              <ShipToStateTable rows={this.state.tableByStates} onExport={() => console.log("Export CSV")} />
            </div>

            {/* Right table: SalespersonNo */}
            <div className="col-12 col-lg-6 d-flex justify-content-center">
              <SalesPersonStateTable rows={this.state.tableBySalesman} onExport={() => console.log("Export CSV")} />
            </div>
          </div>

        </div>
      </div>
    );
  }
}


